import "./create-password.css";
import UpdatePassword from "../../components/UpdatePassword";
import { useSupabaseClient } from "@/hooks/useSupabaseClient";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "@/constant/routes";
import { useEffect, useState } from "react";



const CreatePassword = () => {
    const supabase = useSupabaseClient();
    const navigate = useNavigate();
    const [ready, setReady] = useState(false);
    const [error, setError] = useState<string | null>(null);
  
    useEffect(() => {
      const checkSession = async () => {
        const {
          data: { session },
        } = await supabase.auth.getSession();
  
        if (!session) {
          setError("Le lien d'invitation est invalide ou expiré.");
          return;
        }
  
        setReady(true);
      };
  
      checkSession();
    }, [supabase]);
  

    const onClick = async (password: string) => {
            
      const { error } = await supabase.auth.updateUser({
        password
    });

    if (error) {
        console.log(error);
        return;
    }
    navigate(LOGIN);
    
    }

    return (
      <UpdatePassword 
        description={"Votre mot de passe doit contenir au moins 12 caractères, dont une majuscule, un chiffre et un symbole"} 
        title={"Création de votre mot de passe"}
        onClick={onClick}
      />
    );
};

export default CreatePassword